import React from 'react'

import PropTypes from 'prop-types'

import * as S from './styled'

const Card = ({
  className,
  children,
  bgColor,
  bdColor,
  textColor,
  padding,
  shadow,
  tag
}) => {
  return (
    <S.CardWrapper
      bgColor={bgColor}
      bdColor={bdColor}
      padding={padding}
      as={tag}
      textColor={textColor}
      className={`${className} ${shadow ? `with-shadow-${shadow}dp` : ''}`}
    >
      {children}
    </S.CardWrapper>
  )
}

Card.defaultProps = {
  shadow: '2',
  bgColor: 'white',
  textColor: 'neutral600',
  tag: 'div'
}

Card.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  bgColor: PropTypes.string,
  bdColor: PropTypes.string,
  padding: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  textColor: PropTypes.string,
  shadow: PropTypes.oneOf([
    '0',
    '1',
    '2',
    '3',
    '4',
    'sm-1',
    'sm-2',
    'sm-3',
    'sm-4'
  ]),
  tag: PropTypes.string
}

export default Card
